import { useState, useEffect } from 'react';

/**
 * Retorna true quando a largura da viewport é <= breakpoint (default 768px).
 * Atualiza em tempo real ao redimensionar/rotacionar o dispositivo.
 */
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
